import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { CalendarBoard } from '~/components/calendar/calendar-board'
import { decodeCalendarSearch } from '~/components/calendar/search'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/calendar')({
  component: CalendarPage,
  head: () => ({ meta: [{ title: titleFor(msg`Calendar`) }] }),
  validateSearch: decodeCalendarSearch,
})

function CalendarPage() {
  return <CalendarBoard />
}
